import { vsDialog } from 'vuesax'
import store from '@/store/store';
import Layout from '@/layouts/main/Main.vue'

/**
 *菜单是否展开
 */
export function MenuIsExpand(menu,vm){
  let open          = false;
  function queryName(menu) {
    if (menu.children) {
      menu.children.forEach((innerMenu) => {
        if (innerMenu.componentName == vm.$route.name) { open = true }
        // 特殊的,内页的详情,
        if(menu.componentName == 'wallet' && vm.$route.name == 'customerDetail'){
          open = true;
        }else if(menu.componentName == 'wallet' && vm.$route.name == 'apiTurnoverDetail'){
          open = true;
        }
        else {
          queryName(innerMenu);
        }
      })
    }
  }
  queryName(menu);
  return open;
}

export function download(file) {
  const link = document.createElement('a');
  link.href = file.url;
  link.download = file.fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
}

export const filterAsyncRouter = (menus) => { // 遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = menus.filter(item => {
    if (item.component) {
      if (item.component === 'Layout') { // Layout组件特殊处理
        item.component = Layout;
      } else {
        const component = item.component
        item.component = loadView(component)
        item.path = item.componentName;
      }
    }
    item.meta = {
      title: item.name,
      titleEn: item.nameEn,
      icon: item.icon,
      noCache: false,
      interfaceIds: item.interfaceIds,
      sort: item.sort,
    };
    item.name = item.componentName;

    delete item.icon;
    delete item.id;
    delete item.interfaceIds;
    delete item.nameEn;

    if (item.children && item.children.length) {
      item.children = filterAsyncRouter(item.children);
    }

    return true;
  });
  return accessedRouters;
}

export const loadView = (view) => { // 路由懒加载
  return () => import(`@/views/${view}`);
}

export function setLocalStorage(name, value, timeout) {
  localStorage.setItem(name, JSON.stringify(value));
}

export function getEmailAddress(email) {
  let location=''
  let hash = {
    'qq.com': 'http://mail.qq.com',
    'gmail.com': 'http://gmail.google.com',
    'sina.com': 'http://mail.sina.com.cn',
    '163.com': 'http://mail.163.com',
    '126.com': 'http://mail.126.com',
    'yeah.net': 'http://www.yeah.net/',
    'sohu.com': 'http://mail.sohu.com/',
    'tom.com': 'http://mail.tom.com/',
    'sogou.com': 'http://mail.sogou.com/',
    '139.com': 'http://mail.10086.cn/',
    'hotmail.com': 'http://www.hotmail.com',
    'live.com': 'http://login.live.com/',
    'live.cn': 'http://login.live.cn/',
    'live.com.cn': 'http://login.live.com.cn',
    '189.com': 'http://webmail16.189.cn/webmail/',
    'yahoo.com.cn': 'http://mail.cn.yahoo.com/',
    'yahoo.cn': 'http://mail.cn.yahoo.com/',
    'eyou.com': 'http://www.eyou.com/',
    '21cn.com': 'http://mail.21cn.com/',
    '188.com': 'http://www.188.com/',
    'foxmail.com': 'http://www.foxmail.com',
    'outlook.com': 'http://www.outlook.com'
    }

    let _email = email.split('@')[1];    //获取邮箱域
    if(hash.hasOwnProperty(_email)){
        location = hash[_email];
    }else{
        location = 'mail.'+ _email
    }
    return location
}
//将获取时间格式为yyyy-MM-dd的当前时间
export function getCurrentDate() {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}
//将时间戳转化为24H标准时间
export function changeTimestamp(values) {
  let date = new Date(values);

  let Y = date.getFullYear();
  let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  let time = Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s;
  return time;
}
// 将字符串去重后并返回一个数组
export function filterRepeatStr(str) {
  let ar2 = str.split(',');
  let array = new Array();
  let j = 0;
  for (let i = 0; i < ar2.length; i++) {
    if ((array == '' || array.toString().match(new RegExp(ar2[i], 'g')) == null) && ar2[i] != '') {
      array[j] = ar2[i];
      array.sort();
      j++;
    }
  }
  return array;
}
// 处理语言
export function filtrelang(lang, itme) {
  let result = '';
  if (lang == 'zh_CN') {
    result = itme.columnName
  } else {
    result = itme['columnName' + 'En']
  }
  return result;
}

// 处理语言
export function filtreTaglang(lang, itme) {
  let result = '';
  if (lang == 'zh_CN') {
    result = itme.typeName
  } else {
    result = itme['typeName' + 'En']
  }
  return result;
}
//动态设置文字头部和icon

export function SetTitleAndIcon(res) {
  // document.title = res.siteName || '阿丽塔科技有限公司';

  let linkIcon = document.getElementById('link-icon');
  linkIcon.href = res.icon;
}
export function scrollTop() {
    let docScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if(docScrollTop != 0){
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        window.pageYOffset = 0;
    }
}


/*
 * 获取浏览器版本信息
 */
function getBrowerInfo() {
  let userAgent = window.navigator.userAgent.toLowerCase()
  let browserType = ''
  let browserVersion = ''
  let isIE = userAgent.match(/msie/) != null || userAgent.match(/trident/) != null
  if (userAgent.indexOf("firefox") > 0) {
    browserType = '火狐'
    browserVersion = userAgent.match(/firefox\/([\d.]+)/)[1]
  }
  // 浏览器类型-IE
  if (userAgent.match(/msie/) != null || userAgent.match(/trident/) != null) {
    browserType = 'IE'
    browserVersion = this.getIeVersion()
  }
  // 欧朋
  else if (window.opera || (userAgent.indexOf("opr") > 0)) {
    browserType = '欧朋'
    browserVersion = this.getOperaVersion(userAgent)
  }
  // UC
  else if (userAgent.indexOf("ubrowser") > 0) {
    browserType = 'UC'
    browserVersion = userAgent.match(/ubrowser\/([\d.]+)/)[1]
  }
  // 百度
  else if (userAgent.indexOf("bidubrowser") > 0) {
    browserType = '百度'
    browserVersion = userAgent.match(/bidubrowser\/([\d.]+)/)[1]
  }
  // 搜狗
  else if (userAgent.indexOf("metasr") > 0 || userAgent.indexOf("se 2.x") > 0) {
    browserType = '搜狗'
    // browserVersion =  userAgent.match(/metasr\/([\d.]+)/)[1]
  }
  // QQ
  else if (userAgent.indexOf("tencenttraveler") > 0) {
    browserType = 'QQ'
    browserVersion = userAgent.match(/tencenttraveler\/([\d.]+)/)[1]
  }
  // QQ
  else if (userAgent.indexOf("qqbrowser") > 0) {
    browserType = 'QQ'
    browserVersion = userAgent.match(/qqbrowser\/([\d.]+)/)[1]
  }
  // 遨游
  else if (userAgent.indexOf("maxthon") > 0) {
    browserType = '遨游'
    browserVersion = userAgent.match(/maxthon\/([\d.]+)/)[1]
  }
  // 火狐
  else if (userAgent.indexOf("firefox") > 0) {
    browserType = '火狐'
    browserVersion = userAgent.match(/firefox\/([\d.]+)/)[1]
  }
  // edge
  else if (userAgent.indexOf("edge") > 0) {
    browserType = 'Edge'
    browserVersion = userAgent.match(/edge\/([\d.]+)/)[1]
  }
  // 谷歌/360
  else if (userAgent.indexOf("chrome") > 0) {
    if (this.validate360('type', 'application/x360mmplugin')) {
      browserType = '360'
      // browserVersion =  userAgent.match(/chrome\/([\d.]+)/)[1]
    } else {
      browserType = '谷歌'
      browserVersion = userAgent.match(/chrome\/([\d.]+)/)[1]
    }
  }
  // 苹果
  else if (userAgent.indexOf("Safari") > -1) {
    browserType = 'Safari'
    browserVersion = userAgent.match(/version\/([\d.]+)/)[1]
  }
  return browserType + ' ' + browserVersion
}




/*将图片转为base64*/
export function getBase64(file){
  return new Promise(function(resolve, reject) {
    let reader = new FileReader();
    let imgResult = "";
    reader.readAsDataURL(file);
    reader.onload = function() {
      imgResult = reader.result;
    };
    reader.onerror = function(error) {
      reject(error);
    };
    reader.onloadend = function() {
      // if (file.size > (200 * 1024)) {
      //   if(store.getters.windowBreakPoint == 'sm' || store.getters.windowBreakPoint == 'xs'){
      //     if(file.size > 1.5 * 1024 * 1024){
      //       vsDialog({
      //         title: '上传图片大小超过限制(1.5M)',
      //         type: 'warn'
      //       });
      //       return;
      //     }
      //   }else {
      //     if(file.size > 3 * 1024 * 1024){
      //       vsDialog({
      //         title: '上传图片大小超过限制(3M)',
      //         type: 'warn'
      //       });
      //       return;
      //     }
      //   }
      //   compress(reader.result).then((res) => {
      //     resolve(res);
      //   });
      // } else {
      //
      // }
      resolve(imgResult);
    };
  });
}

export function compress(base64Img){
  return new Promise(function(resolve, reject) {
    var img=new Image();
    img.src=base64Img;
    img.onload = () => {
      var width=img.width;
      var height=img.height;
      var canvas=document.createElement("canvas");
      canvas.width=width;
      canvas.height=height;
      canvas.getContext("2d").drawImage(img,0,0,width,height);
      resolve(canvas.toDataURL('image/jpeg', 0.2));
    };
  });
}



export function TimeDown(totalSeconds) {
  //小时数
  var hours = Math.floor(totalSeconds / (60 * 60));
  //分钟
  var minutes = Math.floor(totalSeconds / 60 % 60);
  //秒
  var seconds = totalSeconds % 60;
  //输出到页面
  let realHours = hours < 10 ? '0'+ hours : hours;
  let realMinutes = minutes < 10 ? '0'+ minutes : minutes;
  let realSeconds = seconds < 10 ? '0'+ seconds : seconds;
  if(hours > 0){
    return realHours + ":" + realMinutes + ":" + realSeconds;
  }else {
    return realMinutes + ":" + realSeconds;
  }
}

export function getIsSuperIsAgentOfcustomer(userInfo){
  if(userInfo.custSource > 0 && userInfo.custType === 3){
    return false;
  }else {
    return true;
  }
}



export function isIncludeMinus(string) {
  if(typeof string == 'number'){
    string = string + '';
  }
  return string && string.includes('-');
}


export function getPayWay(priceType,vm) {
  let text = ''
  switch (priceType) {
    case 0:
      text = vm.$t('Subscription_fee');
      break;
    case 1:
      text =  vm.$t('management_fee');
      break;
    case 2:
      text =  vm.$t('Performance_fee');
      break;
  }
  return text;
}

export function getAccountName(type,tier,vm) {
  switch (type) {
    case 0:
      return vm.$t('Ordinary_account');
    case 2:
      return tier == 1 ? vm.$t('MAM_master_account'): vm.$t('MAM_Investment_Account');
    case 1:
      return tier == 1 ? vm.$t('Social_master_account'): vm.$t('Social_Investment_Account');
    case 3:
      return vm.$t('Wallet_account');
    case 6:
      return vm.$t('Experience_account');
  }
}

// 跳转到对应的详情页
export function jumpDetailsPage(paramsObj) {
  let mtid = paramsObj.signalInfo.id;
  switch (paramsObj.signalInfo.businessType) {
    case 0:
    case 3:
    case 5:
    case 6:
      paramsObj.vm.$router.push({name: 'generalDetails', params: {mtid: mtid}});
      break;
    case 2:
      if(paramsObj.signalInfo.tier == 1){
        paramsObj.vm.$router.push({name: 'mamMasterDetails', params: {mtid: mtid}});
      }else {
        paramsObj.vm.$router.push({name: 'mamSubDetails', params: {mtid: mtid}});
      }
      break;
    case 1:
      if(paramsObj.signalInfo.tier == 1){
        paramsObj.vm.$router.push({name: 'socialMasterDetails', params: {mtid: mtid}});
      }else {
        paramsObj.vm.$router.push({name: 'socialSubDetails', params: {mtid: mtid}});
      }
      break;
  }
}

// 跳转到对应的设置页
export function jumpDetailsSettingPage(paramsObj) {
  let mtid = paramsObj.signalInfo.id;
  switch (paramsObj.signalInfo.businessType) {
    case 0:
    case 3:
    case 5:
      paramsObj.vm.$router.push({name: 'generalDetailsSetting', params: {mtid: mtid}});
      break;
    case 6:
      paramsObj.vm.$router.push({name: 'generalDealPass', params: {mtid: mtid}});
      break;
    case 2:
      if(paramsObj.signalInfo.tier == 1){
        paramsObj.vm.$router.push({name: 'mamMasterFollowSetting', params: {mtid: mtid}});
      }else {
        paramsObj.vm.$router.push({name: 'mamSubFollowSetting', params: {mtid: mtid}});
      }
      break;
    case 1:
      if(paramsObj.signalInfo.tier == 1){
        paramsObj.vm.$router.push({name: 'socialMasterFollowSetting', params: {mtid: mtid}});
      }else {
        paramsObj.vm.$router.push({name: 'socialSubFollowSetting', params: {mtid: mtid}});
      }
      break;
  }
}

// 策略的方式
export function getCopyType(copyType,copyValue,vm){
  if(copyType ==3 && copyValue == 999999999.99){ return '' }
  return copyType == 1 ? vm.$t('Home.forexLot') : vm.$t('multiple');
}

export function getStrategy(row, vm) {
  if(row.copyType === null) return '-'
  let name = row.copyType == 3 ? `${vm.$t('Smart_proportion')}:` : row.copyType == 2 ? `${vm.$t('fixed_proportion')}:` : `${vm.$t('fixed_lots')}:`;
  let value = row.copyValue == 999999999.99 ? `${vm.$t('no_limit')}` : row.copyValue == null ? '-': row.copyValue;
  let unit = getCopyType(row.copyType,row.copyValue, vm);
  return `${name} ${value} ${unit}` ;
}

// 启用中和待结算以及已结算列表,的开始时间和结束时间
export function getDuringDate(dateInfo){
  if(!dateInfo.beginTime) return '-';
  return dateInfo.beginTime + '-' + dateInfo.expireDate;
}
// 复制跟单-收入和支出列表-支出和收入具体
export function getPrice(row,vm){
  let leftText = '';
  switch (row.priceType) {
    case 0:
      leftText = `${vm.$t('Subscription_fee')}*${vm.$t('month')}: `;
      break;
    case 1:
      leftText = `${vm.$t('Management_fee_ratio')}*${vm.$t('Manage_funds')}: `;
      break;
    case 2:
      leftText = `${vm.$t('Performance_fee_ratio')}*${vm.$t('Follow_income')}: `;
      break;
  }
  return leftText + row.priceDetail;
}

export function setSufx(number){
  let str = '';
  if(number >= 0){
    str += '$' + number;
  }else {
    str += '-$' + Math.abs(number);
  }
  return str;
}


export function phFileter(data,vm) {
  return vm.$t(data);
}

export function getProportionPrefixList(){
  return [
    {
      value: 1,
      label: 1,
    },
    {
      value: 5,
      label: 5,
    },
    {
      value: 10,
      label: 10,
    },
    {
      value: 20,
      label: 20,
    },
    {
      value: 40,
      label: 40,
    },
    {
      value: 50,
      label: 50,
    },
    {
      value: 60,
      label: 60,
    },
    {
      value: 80,
      label: 80,
    },
    {
      value: 100,
      label: 100,
    },
  ];
}
export function getSelectList(sharePriceList,outerIndex){
  let tempArr = JSON.parse(JSON.stringify(getProportionPrefixList()));
  for (let j = sharePriceList.length - 1; j >= 0; j--) {
    for (let i = tempArr.length - 1; i >= 0; i--) {
      if(sharePriceList[j].profitValue == tempArr[i].value && j !== outerIndex){
        tempArr.splice(i,1);
      }
    }
  }
  return tempArr;
}
